// extracted by mini-css-extract-plugin
export default {"tabela":"styles_tabela__qtgOR","header":"styles_header__3BAzv","btnRow":"styles_btnRow__OiY8u","activeBtn":"styles_activeBtn__BBVMS","thcenter":"styles_thcenter__FsW-6"};